import { QueovalBase } from "..";

export class GenericEffectif extends QueovalBase {
  public Id: string;

  public Text: string;

  public Picture: string;

  public TelNumFixe: string

  public TelNumMobil: string;

  public Email: string;

  public Infos: string;

  public IsSelected: boolean;

  public HasExtranetAcces: boolean;

  public UrlExtranetAcces: string;

  public ExtranetMailSend: boolean;

  public Type: string;

  public ToolTip: string;

  public LinkInfos: string;

  public IdActionCo: string;

  public IdClient: Array<string>;

  public TextWarning: string;
}
